import cn from 'classnames'
import type { ReactNode } from 'react'

import styles from './CockpitExpandButton.module.scss'

interface ICockpitExpandButtonProps {
  children: ReactNode
  className?: string
  expanded?: boolean
  /** Id of the region the button reveals, for screen readers to tie the two together. */
  ariaControls?: string
  title?: string
  onClick: () => void
}

export const CockpitExpandButton = ({
  children,
  className,
  expanded,
  ariaControls,
  title,
  onClick,
}: ICockpitExpandButtonProps) => (
  <button
    type="button"
    className={cn(styles.root, className)}
    aria-controls={ariaControls}
    aria-expanded={expanded}
    title={title}
    onClick={onClick}
  >
    {children}
  </button>
)

CockpitExpandButton.displayName = 'CockpitExpandButton'
